import {
  LOAD_FAILURE,
  LOAD_SUCCESS,
  START_LOAD
} from '../actions/contacts';

export const INITIAL_STATE = {
  error: null,
  isLoading: true,
  people: [],
  companies: []
};

export default function(state = INITIAL_STATE, action) {
  switch (action.type) {
  case LOAD_FAILURE:
    return { ...state, error: action.payload.error, isLoading: false };
  case LOAD_SUCCESS: {
    const newState = { ...state, error: null, isLoading: false };
    const { people, companies } = action.payload;

    if (people) newState.people = people;
    if (companies) newState.companies = companies;

    return newState;
  }
  case START_LOAD:
    return { ...state, error: null, isLoading: true };
  default:
    return state;
  }
}
